<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div
      class="container-box"
      :style="{ background: theme.bgColor + ' url(' + ('https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/' + theme.bg) + ') no-repeat top center', }">
      <div>
        <!-- <div class="tidings-wall-box" v-if="isPc? false: true">
          <el-button @click="gotoWall" :style="`background: ${theme.themeColor};color: #fff; font-size:18px;border: none;`" size="mini">喜报墙</el-button>
        </div> -->
        <div class="content-start" v-if="isPc? true: false">
          <el-tooltip content="切换主题" placement="right-start" effect="light">
            <div>
              <el-button :style="`background: ${theme.otherBgColor};color: #fff; font-size:18px;border: none;`" size="mini" @click="changeTheme">主题<i class="el-icon-magic-stick el-icon--right"></i></el-button>
            </div>
          </el-tooltip>
        </div>
        <section class="calcu-content">
          <div class="content-table">
            <div class="innerBg">
              <img
                :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/${theme.lableBg}`"
              />
            </div>
            <div class="innerBg-box"></div>
            <div class="tab-box">
              <div class="selection-area">
                <div v-for="item in activeTab" :key="item.active" @click="changeTab(item.active)">
                  <template v-if="item.children.length>0">
                    <el-dropdown :trigger="isPc?'hover':'click'" @command="clickDropdownMenu" placement="bottom-start">
                      <div
                        v-if="item.show"
                        class="sel-tab long-sel-tab"
                        :style="{ background: 'url(' + require('./../assets/' + theme.tabbt) + ') no-repeat 0 0/100% 100%', }"
                      >
                        <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>

                        <span v-if="!isPc">{{ item.titleS }}</span>
                        <span v-if="!isPc">{{ item.titleF }}</span>
                        <i v-if="isPc" class="add-tips">{{ item.tip }}</i>
                      </div>
                      <div
                        v-else
                        class="sel-tab long-sel-tab"
                        :style="{ background: 'url(' + require('./../assets/greytabbt.png') + ') no-repeat 0 0/100% 100%', }"
                      >
                        <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>

                        <span v-if="!isPc">{{ item.titleS }}</span>
                        <span v-if="!isPc">{{ item.titleF }}</span>
                        <i v-if="isPc" class="add-tips">{{ item.tip }}</i>
                      </div>
                      <el-dropdown-menu v-if="item.children.length>0" slot="dropdown" :class="theme.tabsBg">
                        <el-dropdown-item v-for="it in item.children" :command="it" :key="it.id">{{it.title}}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                  <template v-else>
                    <div
                      v-if="item.show"
                      class="sel-tab long-sel-tab"
                      :style="{ background: 'url(' + require('./../assets/' + theme.tabbt) + ') no-repeat 0 0/100% 100%', }"
                    >
                      <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>

                      <span v-if="!isPc">{{ item.titleS }}</span>
                      <span v-if="!isPc">{{ item.titleF }}</span>
                      <i v-if="isPc" class="add-tips">{{ item.tip }}</i>
                    </div>
                    <div
                      v-else
                      class="sel-tab long-sel-tab"
                      :style="{ background: 'url(' + require('./../assets/greytabbt.png') + ') no-repeat 0 0/100% 100%', }"
                    >
                      <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>

                      <span v-if="!isPc">{{ item.titleS }}</span>
                      <span v-if="!isPc">{{ item.titleF }}</span>
                      <i v-if="isPc" class="add-tips">{{ item.tip }}</i>
                    </div>
                  </template>

                </div>
              </div>
            </div>
            <div class="table-box">
              <div class="table">
                <div class="sel-header" :style="{ background: theme.themeColor }">
                  <div class="sel-tips">
                    <span v-if="isPc || nowActive.active == 1||nowActive.active == 6">
                      {{ nowActive.title }}{{ nowActive.titleS }}{{ nowActive.titleF }}{{ nowActive.tip }}
                    </span>
                    <span v-else-if="nowActive.active === 2">
                      {{ filterActive(areaActiveName) }}
                    </span>
                    <span v-else-if="nowActive.active === 8">
                      {{ filterActive(volunteerActiveName) }}
                    </span>
                    <span v-else-if="nowActive.active === 5">
                      {{ filterActive(unitActiveName) }}
                    </span>
                    <span v-else-if="nowActive.active === 10">
                      {{ nowPosterData.title }}
                    </span>
                    <div
                      v-if="nowActive.active == 1 ? true : false"
                      class="tips-top"
                    >
                      <span class="top-link" @click="openIframe(1)">总数Top10</span>
                      <span class="top-link" @click="byCategoryFindTop(1,'企业',10)">全国企业Top10</span>
                      <span class="top-link" @click="educationCollect(1, '企业')" >全国企业</span>
                      <span class="top-link" @click="byCategoryFindTop(1,'学校',10)" >全国学校Top10</span>
                      <span class="top-link" @click="educationCollect(1, '学校')" >全国学校</span>
                      <span class="top-link" @click="cityCollect" >城市Top100</span>
                    </div>
                    <div
                      v-if="nowActive.active == 2 ? true : false"
                      class="tips-top"
                    >
                      <span class="top-link" @click="areaCityCollect" >城市Top100</span>
                    </div>
                    <div class="update-time" v-if="isPc">
                      数据统计截止到 <span v-if="updateTime">{{updateTime}}</span>
                    </div>
                  </div>
                </div>
                <!-- 筛选工具栏 -->
                <el-row :gutter="10">
                  <div style="text-align:right;margin-top:5px;margin-right:10px;" v-if="!isPc">
                  数据统计截止到 <span v-if="updateTime">{{updateTime}}</span>
                  </div>
                  <div v-show="nowActive.active == 8&&isPc" class="tabs-box tabs-box-3">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="volunteerActiveName"
                          @tab-click="changeVolunteerTabelTab">
                          <el-tab-pane label="网安联·志愿服务站" name="first">
                          </el-tab-pane>
                          <el-tab-pane label="网安联·志愿服务队" name="second">
                          </el-tab-pane>
                          <el-tab-pane label="其他志愿团体" name="four">
                          </el-tab-pane>
                          <el-tab-pane label="公益讲师" name="five">
                          </el-tab-pane>
                          <el-tab-pane label="志愿者" name="three">
                          </el-tab-pane>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-show="nowActive.active == 2&&isPc" class="tabs-box tabs-box-2">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="areaActiveName"
                          @tab-click="changeAreaTabelTab">
                          <el-tab-pane label="样本采集（汇总统计）" name="first">
                          </el-tab-pane>
                          <el-tab-pane label="主问卷/专题采集量（数量汇总）" name="second">
                          </el-tab-pane>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-show="nowActive.active == 5&&isPc" class="tabs-box tabs-box-2">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="unitActiveName"
                          @tab-click="changeUnitTabelTab">
                          <el-tab-pane label="发起单位" name="first">
                          </el-tab-pane>
                          <el-tab-pane label="联合发起单位" name="three">
                          </el-tab-pane>
                          <!-- 推荐单位链接需要放开 -->
                          <!-- <el-tab-pane label="推荐单位" name="second">
                          </el-tab-pane> -->
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <!-- 1:省市2:区域5:发起单位 6:各链接 -->
                  <div
                    :class="(nowActive.active == 1 || nowActive.active == 2)? 'tool-bar end-tool-bar' : 'tool-bar'"
                  >
                    <el-col :span="isPc? 6:(unitActiveName=='second'?18:12) " v-show="nowActive.active == 5">
                      <div class="tool-input">
                        <el-input
                          :placeholder="unitActiveName === 'second'? '请输入推荐单位': (unitActiveName === 'three'?'请输入联合发起单位':'请输入发起单位')"
                          v-model="toolData.recommended"
                          clearable
                          :size="isPc?'medium':'mini'"
                        >
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 6: (unitActiveName=='second'?6:12) "
                      v-show="nowActive.active == 5">
                      <el-button
                        :loading="loading"
                        @click="searchEvent"
                        plain
                        :size="isPc?'medium':'mini'"
                      >搜索</el-button>
                      <el-button
                        v-if="unitActiveName==='first'||unitActiveName==='three'"
                        @click="exportData"
                        plain
                        :size="isPc?'medium':'mini'"
                        >导出</el-button
                      >
                    </el-col>
                    <!-- 服务站,服务队 -->
                    <template v-if="nowActive.active == 8 && !showMap">
                      <el-col :span="isPc? 6 : 12 ">
                        <div class="tool-input">
                          <el-input
                            placeholder="请输入关键字搜索"
                            v-model="toolData.volunteerOrgName"
                            clearable
                            :size="isPc?'medium':'mini'"
                          >
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="isPc? 6 : 12 ">
                        <el-button
                          :loading="loading"
                          @click="searchEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                          >搜索</el-button
                        >
                        <el-button
                          @click="exportData"
                          plain
                          :size="isPc?'medium':'mini'"
                          >导出</el-button
                        >
                      </el-col>

                    </template>
                    <template v-if="nowActive.active == 8 && (volunteerActiveName === 'first' || volunteerActiveName === 'second') && showMap">
                      <el-col :span="isPc? 24 : 24 ">
                        <div style="text-align:right;display: flex; justify-content: flex-end;">
                          <el-button
                            @click="tableEvent"
                            plain
                            :size="isPc?'medium':'mini'"
                            >表格统计</el-button>
                        </div>
                      </el-col>
                    </template>

                    <el-col :span="isPc? 5 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-select
                          v-model="toolData.province"
                          @change="changeProvince"
                          filterable
                          clearable
                          placeholder="请选择省"
                          :size="isPc?'medium':'mini'"
                        >
                          <el-option
                            v-for="item in provinceList"
                            :key="item.province"
                            :label="item.province"
                            :value="item.province"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-select
                          v-model="toolData.city"
                          filterable
                          clearable
                          placeholder="请选择市"
                          :size="isPc?'medium':'mini'"
                        >
                          <el-option
                            v-for="item in cityList"
                            :key="item.city"
                            :label="item.city"
                            :value="item.city"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >

                        <el-cascader
                          v-model="toolData.category"
                          :options="sortList"
                          :props="{ checkStrictly: true, value: 'id', label: 'categoryName' }"
                          clearable
                          filterable
                          placeholder="请选择分类"
                          :size="isPc?'medium':'mini'"
                        >
                        </el-cascader>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 12 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-input
                          placeholder="请输入所属名称或来源名称或ID"
                          v-model="toolData.sourceName"
                          clearable
                          :size="isPc?'medium':'mini'"
                        >
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 4 : 12 "
                      v-show="nowActive.active == 6">
                      <el-button
                        :loading="loading"
                        @click="searchEvent"
                        plain
                        :size="isPc?'medium':'mini'"
                        >搜索</el-button
                      >
                      <el-button
                        @click="exportData"
                        plain
                        :size="isPc?'medium':'mini'"
                        >导出</el-button
                      >
                    </el-col>
                    <el-col :span="24"
                      v-show="(nowActive.active == 1 || nowActive.active == 2) && !showMap">
                      <div style="display: flex;justify-content: end;">
                        <el-button
                          @click="mapEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                        >地图统计</el-button>
                        <el-button
                          @click="exportData"
                          plain
                          :size="isPc?'medium':'mini'"
                        >导出</el-button>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 3 : 8 "
                      v-show="(nowActive.active == 1 || nowActive.active == 2) && showMap">
                      <el-button
                        @click="tableEvent"
                        plain
                        :size="isPc?'medium':'mini'"
                        >表格统计</el-button>
                    </el-col>
                  </div>
                </el-row>
                <div class="caculate-area">
                  <div class="data-scroll-area">
                    <!-- 参与答题网名区域分布:2和各省市实际采集量:1表格 -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table v-if="nowActive.active == 1 &&!showMap"
                        v-loading="tableDataLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="provincesAndCitiesData"
                        :max-height="isPc?screenHeight-50:'90000'"
                        style="width:100%;"
                        :header-cell-style="{background:'#F2F4F5'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="table"
                        fixed
                        :tree-props="{ children: 'childrenList' }"
                        :border="isPc?false:true"
                      >
                        <el-table-column label="序号" :width="isPc?'100':'35'" align="right">
                           <template slot-scope="scope">
                            <span>{{ scope.row.id | filterIdS }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="区域" :width="isPc?'':''" align="center">
                          <template slot-scope="scope">
                            <span v-if="!!scope.row.sourceList"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </span>
                            <span v-else
                            >
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column label="样本采集量" align="center">
                          <el-table-column label="主问卷" align="center">
                            <el-table-column label="小计" :width="isPc?'':'55'" align="center">
                              <template slot-scope="scope">
                                <div>
                                  {{ scope.row.amount }}
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column prop="percentDesc" label="占比" :width="isPc?'':'50'" align="center">
                            </el-table-column>
                            <el-table-column prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
                            </el-table-column>
                            <el-table-column prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
                            </el-table-column>
                          </el-table-column>
                          <el-table-column prop="specialAmount" label="专题问卷" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column prop="totalAmount" :label="'总样本量\n(主+专)'" :width="isPc?'':'55'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ scope.row.amount+scope.row.specialAmount }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table-column>

                        <!-- <el-table-column label="操作" :width="isPc?'':'40'" align="center" prop="">
                          <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
                            <el-button v-if="(scope.row.amount+(!!scope.row.specialAmount?scope.row.specialAmount:0))>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
                          </template>
                        </el-table-column> -->
                      </el-table>
                    </div>
                    <!-- 样本采集（汇总统计） -->
                    <div class="total-table-2"
                      v-if="(nowActive.active == 2 && areaActiveName==='first') &&!showMap"
                      style="overflow-x: auto;"
                    >
                      <el-table
                        v-loading="tableDataAreaLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="totalAreaData"
                        :max-height="isPc?screenHeight-50:'90000'"
                        style="width:100%;"
                        :header-cell-style="{background:'#F2F4F5'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="area"
                        :tree-props="{ children: 'sublist' }"
                        :border="isPc?false:true"
                        :row-class-name="tableRowClassName"
                        header-align="center"
                        :span-method="arraySpanMethod"
                      >
                        <el-table-column label="序号" :width="isPc?'80':'35'" align="right">
                          <template slot-scope="scope">
                            <span v-if="scope.row.id==0&&!isPc">全国</span>
                            <span v-else>{{ scope.row.id | filterIdS }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="区域" :width="isPc?'':'38'" align="center">
                          <template slot-scope="scope">
                            <span v-if="!!scope.row.isClick && (!!scope.row.district || !!scope.row.city || scope.row.city ==='广州市')"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </span>
                            <span v-else
                            >
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column label="总样本量" align="center" :width="isPc?'':'55'">
                          <template slot-scope="scope">
                            <span>
                              {{ scope.row.totalAmount }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="主问卷总量 " align="center" :min-width="isPc?'':'21%'">
                        </el-table-column>
                        <el-table-column v-if="isPc" prop="percentDesc" label="总占比 " align="center" width="">
                        </el-table-column>
                        <el-table-column prop="publicAmount" label="公众主问卷合计" align="center" :min-width="isPc?'':'21%'">
                        </el-table-column>
                        <el-table-column prop="employmentAmount" label="从业主问卷合计" align="center" :min-width="isPc?'':'20%'">
                        </el-table-column>
                        <el-table-column prop="specialAmount" label="专题问卷总量" align="center" :min-width="isPc?'':'21%'">
                        </el-table-column>
                        <el-table-column label="操作" :width="isPc?'':'40px'" align="center" prop="">
                          <template slot-scope="scope">
                            <el-button v-if="scope.row.totalAmount>1000" @click="createPlacard(scope.row, 2)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div v-show="showMap">
                      <div
                        id="mapContainer"
                        class="calDataShow mapDivisionData"
                        :style="isPc?'width:100%;height:1100px;':'width:700px;height: 700px;'"
                      ></div>
                    </div>
                    <!-- subject主问卷/专题采集量 （数量汇总） -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table
                        v-if="(nowActive.active == 2 && areaActiveName==='second') &&!showMap"
                        v-loading="subjectLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="subjectTableData"
                        style="width:100%;border: 2px solid #ebeef5;"
                        :header-cell-style="{background:'#F2F4F5'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="subject"
                        :tree-props="{ children: 'sublist' }"
                        :border="true"
                        :row-class-name="tableRowClassName"
                      >
                        <el-table-column label="序号" :width="isPc?'60':'35'" align="right" fixed="left">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id | filterId }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="所属区域" width="" align="center" fixed="left">
                          <template slot-scope="scope">
                            <span v-if="!!scope.row.isClick && (!!scope.row.city || scope.row.city ==='广州市')"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </span>
                            <span v-else
                            >
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column label="网民答题(主间卷、专题问卷)数量汇总" align="center">
                          <el-table-column :label="'总样本量\n(A+B)'" align="center" width="">
                            <template slot-scope="scope">
                              <span>
                                {{ scope.row.amount + scope.row.specialAmount }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column :label="'主问卷量\n(A1+B1)'" prop="amount" width="" align="center">
                          </el-table-column>
                          <el-table-column :label="'专题问卷量\n(A2+B2)'" prop="specialAmount" width="" align="center">
                          </el-table-column>
                          <el-table-column :label="'公众网民版\nA'" align="center">
                            <el-table-column :label="'主问卷\n小计\nA1'" prop="publicAmount" min-width="70" align="center">
                            </el-table-column>
                            <el-table-column :label="'专题问卷\nA2'" align="center">
                              <el-table-column :label="'专题问卷\n小计\nA2'" prop="publicSpecialAmount" width="75" align="center">
                              </el-table-column>
                              <el-table-column :label="'网络安全法治社会建设\nA21'" prop="publicSpecial1Amount" width="65" align="center">
                              </el-table-column>
                              <el-table-column :label="'网络诚信建设\nA22'" prop="publicSpecial2Amount" width="65" align="center">
                              </el-table-column>
                              <el-table-column :label="'遏制惩处网络违法犯罪行为\nA23'" prop="publicSpecial3Amount" width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'个人信息保护和数据安全\nA24'" prop="publicSpecial4Amount" width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'网络购物权益保护\nA25'" prop="publicSpecial5Amount" width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'特殊人群（未成年人和老人等）网络权益保护\nA26'" prop="publicSpecial6Amount" width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'互联网平台监管与企业自律\nA27'" prop="publicSpecial7Amount" width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'数字政府服务与治理能力提升\nA28'" prop="publicSpecial8Amount" width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'网络社会发展的变化与冲击\nA29'" prop="publicSpecial9Amount" min-width="70" align="center">
                              </el-table-column>
                            </el-table-column>
                          </el-table-column>
                          <el-table-column :label="'从业人员版\nB'" align="center">
                            <el-table-column :label="'主问卷\n小计\nB1'" prop="employmentAmount" min-width="70" align="center">

                            </el-table-column>
                            <el-table-column :label="'专题问卷\nB2'" align="center">
                              <el-table-column :label="'专题问卷\n小计\nB2'" prop="employmentSpecialAmount" min-width="75" align="center">

                              </el-table-column>
                              <el-table-column :label="'行业治理与企业合规\nB21'" prop="employmentSpecialAAmount" min-width="65" align="center">

                              </el-table-column>
                              <el-table-column :label="'行业发展与科技创新\nB22'" prop="employmentSpecialBAmount" min-width="65" align="center">
                              </el-table-column>
                              <el-table-column :label="'新技术挑战与网络安全\nB23'" prop="employmentSpecialCAmount" min-width="65" align="center">
                              </el-table-column>
                            </el-table-column>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 发起、推荐单位采集量 -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table v-if="nowActive.active == 5"
                        v-loading="recommendTableDataLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :ref="unitActiveName==='second'?'recommended':(unitActiveName==='three'?'joint':'initiate')"
                        :data="unitActiveName==='second'?recommendTableData:(unitActiveName==='three'?jointTableData:initiateTableData)"
                        :max-height="isPc?screenHeight-50:'90000'"
                        style="width: 100%"
                        :fit="true"
                        :header-cell-style="{background:'#F2F4F5'}"
                        :border="isPc?false:true"
                        row-key="id"
                        :tree-props="{ children: 'childrenList' }"
                      >
                        <el-table-column label="序号" :width="isPc?'90':'35'" align="center">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id | filterIdS }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column :label="unitActiveName === 'second'? '推荐单位': (unitActiveName === 'three'?'联合发起单位':'发起单位')" :width="isPc?'230':'80'" align="center">
                          <template slot-scope="scope">
                            <div
                              v-if="!!scope.row.sourceList"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </div>
                            <div v-else>
                              {{ scope.row.name }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="总样本量" align="center">
                          <el-table-column :label="'实际数\nX+Y'" :width="isPc?'':'55'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ scope.row.amount+scope.row.specialAmount }}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column :label="'折算数\nX+Z'" :width="isPc?'':'55'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ (scope.row.amount+(scope.row.specialAmount/4)).toFixed(1) }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="主问卷采集量" align="center" :width="isPc?'':'55'">
                          <el-table-column prop="amount" :label="'小计\nX'" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column v-if="isPc" prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column v-if="isPc" prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                        </el-table-column>

                        <el-table-column label="专题问卷采集量" align="center" :width="isPc?'':'55'">
                          <el-table-column prop="specialAmount" :label="'实际数\nY'" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column :label="'折算数\nZ'" :width="isPc?'':'55'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ (scope.row.specialAmount/4).toFixed(1) }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="操作" :width="isPc?'':'40'" align="center" prop="">
                          <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
                            <el-button v-if="(scope.row.amount+(!!scope.row.specialAmount?scope.row.specialAmount:0))>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 各链接采集量 -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table v-if="nowActive.active == 6"
                        ref="thePublic"
                        v-loading="thePublicLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="collectBaseList"
                        :header-cell-style="{background:'#F2F4F5'}"
                        key="thePublic"
                        style="width: 100%;border: 2px solid #ebeef5;"
                        stripe
                        :fit="true"
                        :border="isPc?false:true"
                        :row-class-name="tableRowClassName"
                        :default-sort = "{prop: 'totalAmount', order: 'descending'}"
                      >
                        <el-table-column type="index" label="序号" :width="isPc?'55':'32'" align="center" fixed="left">
                        </el-table-column>
                        <el-table-column v-if="isPc" prop="province" :label="isPc?'所属区域':'区域'" :width="isPc?'60':'40'" align="center" fixed="left">
                        </el-table-column>
                        <el-table-column v-if="isPc" prop="city" :label="isPc?'城市':'市'" :width="isPc?'72':'35'" align="center">
                        </el-table-column>
                        <el-table-column v-if="isPc" prop="category" label="分类" :width="isPc?'72':'55'" align="center">
                        </el-table-column>
                        <el-table-column v-if="isPc" prop="associatedName" label="所属名称" :width="isPc?'72':'50'" align="center">
                        </el-table-column>
                        <el-table-column prop="sourceName":label="'来源渠道\n(ID)'" :width="isPc?'':'55'" align="center" :fixed="!isPc">
                          <template slot-scope="scope">
                            <div>
                              {{ scope.row.sourceName }}{{ scope.row.sourceId?`(${scope.row.sourceId})`:'' }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="总样本量" align="center">
                          <el-table-column prop="totalAmount" :label="'实际数\nX+Y'" :width="isPc?'':'55'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ scope.row.amount+scope.row.specialAmount }}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column :label="'折算数\nX+Z'" :width="isPc?'':'65'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ (scope.row.amount+(scope.row.specialAmount/4)).toFixed(1) }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="主问卷采集量" align="center" :width="isPc?'':'55'">
                          <el-table-column prop="amount" :label="'小计\nX'" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column v-if="isPc" prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column v-if="isPc" prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                        </el-table-column>

                        <el-table-column label="专题问卷采集量" align="center" :width="isPc?'':'55'">
                          <el-table-column prop="specialAmount" :label="'实际数\nY'" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column :label="'折算数\nZ'" :width="isPc?'':'60'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ (scope.row.specialAmount/4).toFixed(1) }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="操作" :width="isPc?'':'40'" align="center" prop="">
                          <template slot-scope="scope">
                            <el-button v-if="scope.row.sourceName!='合计'&&(scope.row.amount+(!!scope.row.specialAmount?scope.row.specialAmount:0))>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
                            <!-- 推荐单位链接需要放开 -->
                            <!-- <el-button v-else-if="scope.row.sourceName==='合计'" @click="getPlacardInfo(scope.row)" type="warning" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button> -->
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 志愿服务 -->
                    <div class="total-table-2 total-table-3" v-if="nowActive.active == 8" style="overflow-x: auto;">
                      <el-table
                        v-loading="volunteerLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :ref="`volunteer${volunteerActiveName}`"
                        :data="volunteerTabTableData"
                        :header-cell-style="{background:'#F2F4F5'}"
                        stripe
                        :max-height="isPc?screenHeight-50:'90000'"
                        style="width:100%;"
                        row-key="id"
                        :tree-props="{ children: 'childrenList' }"
                        :border="isPc?false:true"
                      >
                        <el-table-column label="序号" :width="isPc?'80':'38'" align="center">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id | filterId }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="volunteerActiveName === 'second'?'志愿服务队':(volunteerActiveName === 'three'?'志愿者':(volunteerActiveName === 'four'?'其他志愿团体':(volunteerActiveName === 'five'?'公益讲师':'志愿服务站')))"
                          :width="isPc?'230':''" align="center">
                          <template slot-scope="scope">
                            <div v-if="!!scope.row.sourceList"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </div>
                            <div v-else>{{ scope.row.name }}</div>
                          </template>
                        </el-table-column>
                        <el-table-column label="总样本量" align="center">
                          <el-table-column :label="'实际数\nX+Y'" :width="isPc?'':'55'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ scope.row.amount+scope.row.specialAmount }}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column :label="'折算数\nX+Z'" :width="isPc?'':'60'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ (scope.row.amount+(scope.row.specialAmount/4)).toFixed(1) }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="主问卷采集量" align="center" :width="isPc?'':'55'">
                          <el-table-column prop="amount" :label="'小计\nX'" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column v-if="isPc" prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column v-if="isPc" prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                        </el-table-column>

                        <el-table-column label="专题问卷采集量" align="center" :width="isPc?'':'55'">
                          <el-table-column prop="specialAmount" :label="'实际数\nY'" :width="isPc?'':'55'" align="center">
                          </el-table-column>
                          <el-table-column :label="'折算数\nZ'" :width="isPc?'':'60'" align="center">
                            <template slot-scope="scope">
                              <div>
                                {{ (scope.row.specialAmount/4).toFixed(1) }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="操作" :width="isPc?'':'40'" align="center" prop="">
                          <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
                            <el-button v-if="(scope.row.amount+(!!scope.row.specialAmount?scope.row.specialAmount:0))>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 喜报墙 -->
                    <div v-show="nowActive.active == 10">
                      <div class="content-box-title"> {{ nowPosterData.title }} </div>
                      <el-row>
                        <template v-for="(item,index) in nowPosterData.topList" >
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="item.topData.length>0">
                            <wall :title="item.name" :type="nowPosterData.title" :dataList="item.topData" :tabbt="theme.tabbt" :isPc="isPc" @onClick="createPlacard" ></wall>
                          </el-col>
                        </template>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- 全国企业采集量 -->
    <el-dialog
      :title="dialogRecommendTitle"
      :visible.sync="dialogRecommendTable"
      center
      :width="isPc?'90%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box total-table-2">
        <el-table
          v-if="dialogRecommendTable"
          v-loading="dialogRecommendLoading"
          :data="dialogRecommendData"
					:header-cell-style="{background:'#F2F4F5'}"
          :height="screenHeight-100"
          stripe
          :row-class-name="tableRowClassName"
          header-align="center"
        >
          <el-table-column type="index" label="序号" :width="isPc?'100':'35'" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index===0?' ':scope.$index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="省" :width="isPc?'':'35'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column v-if="isPc" label="城市" :width="isPc?'':'40'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column v-if="isPc" prop="category" label="分类" :width="isPc?'':'35'" align="center"> </el-table-column>
          <el-table-column label="来源渠道" :width="isPc?'':''" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.sourceName }}
              </div>
            </template>
          </el-table-column>
          <template v-if="nowActive.active ===1">
            <el-table-column label="主问卷" align="center">
              <el-table-column label="小计" :width="isPc?'':'55'" align="center">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.amount }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
              </el-table-column>
              <el-table-column prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
              </el-table-column>
            </el-table-column>
            <el-table-column prop="specialAmount" label="专题问卷" :width="isPc?'':'55'" align="center">
            </el-table-column>
            <el-table-column prop="totalAmount" :width="isPc?'':'55'" align="center">
              <template slot="header">
                <div>总样本量</div>
                <div>(主+专)</div>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.amount+scope.row.specialAmount }}
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column label="总样本量" align="center">
              <el-table-column prop="totalAmount" :width="isPc?'':'55'" align="center">
                <template slot="header">
                  <div>实际数</div>
                  <div>X+Y</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.amount+scope.row.specialAmount }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column :width="isPc?'':'60'" align="center">
                <template slot="header">
                  <div>折算数</div>
                  <div>X+Z</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    {{ (scope.row.amount+(scope.row.specialAmount/4)).toFixed(1) }}
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="主问卷采集量" align="center" :width="isPc?'':'55'">
              <el-table-column prop="amount" :width="isPc?'':'55'" align="center">
                <template slot="header">
                  <div>小计</div>
                  <div>X</div>
                </template>
              </el-table-column>
              <el-table-column v-if="isPc" prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
              </el-table-column>
              <el-table-column v-if="isPc" prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
              </el-table-column>
            </el-table-column>
            <el-table-column label="专题问卷采集量" align="center" :width="isPc?'':'55'">
              <el-table-column prop="specialAmount" :width="isPc?'':'55'" align="center">
                <template slot="header">
                  <div>实际数</div>
                  <div>Y</div>
                </template>
              </el-table-column>
              <el-table-column :width="isPc?'':'60'" align="center">
                <template slot="header">
                  <div>折算数</div>
                  <div>Z</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    {{ (scope.row.specialAmount/4).toFixed(1) }}
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
          </template>
          <el-table-column label="操作" :width="isPc?'':'50'" align="center" prop="">
            <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
              <el-button v-if="scope.row.amount>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- dialogcityTopLoading 各省市列 城市top100 -->
    <el-dialog
      title="城市Top100"
      :visible.sync="dialogcityTop"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box">
        <el-table
          v-loading="dialogcityTopLoading"
          :data="cityTableDataTop100"
					:header-cell-style="{background:'#F2F4F5'}"
          :height="screenHeight-100"
          stripe
        >
        <!-- 序号，城市，所属省，总数，公众，从业 -->
          <el-table-column type="index" label="序号" :width="isPc?'100':'35'" align="center">
          </el-table-column>
          <el-table-column label="城市" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column label="所属省" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column label="总样本量" align="center">
            <el-table-column prop="totalAmount" :width="isPc?'':'55'" align="center">
              <template slot="header">
                <div>实际数</div>
                <div>X+Y</div>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.amount+scope.row.specialAmount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :width="isPc?'':'60'" align="center">
              <template slot="header">
                <div>折算数</div>
                <div>X+Z</div>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.amount+(scope.row.specialAmount/4)).toFixed(1) }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="主问卷采集量" align="center" :width="isPc?'':'55'">
            <el-table-column prop="amount" :width="isPc?'':'55'" align="center">
              <template slot="header">
                <div>小计</div>
                <div>X</div>
              </template>
            </el-table-column>
            <el-table-column v-if="isPc" prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
            </el-table-column>
            <el-table-column v-if="isPc" prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
            </el-table-column>
          </el-table-column>

          <el-table-column label="专题问卷采集量" align="center" :width="isPc?'':'55'">
            <el-table-column prop="specialAmount" :width="isPc?'':'55'" align="center">
              <template slot="header">
                <div>实际数</div>
                <div>Y</div>
              </template>
            </el-table-column>
            <el-table-column :width="isPc?'':'60'" align="center">
              <template slot="header">
                <div>折算数</div>
                <div>Z</div>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.specialAmount/4).toFixed(1) }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 网民列城市Top100 -->
    <el-dialog
      title="城市Top100"
      :visible.sync="dialogAreaCityTop"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box">
        <el-table
          v-loading="dialogAreaCityTopLoading"
          :data="areaCityTableDataTop100"
					:header-cell-style="{background:'#F2F4F5'}"
          :height="screenHeight-100"
          stripe
        >
        <!-- 序号，城市，所属省，总数，公众，从业 -->
          <el-table-column type="index" label="序号" :width="isPc?'100':'35'" align="center">
          </el-table-column>
          <el-table-column label="城市" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column label="所属省" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column label="总样本量" align="center">
            <el-table-column prop="totalAmount" :width="isPc?'':'55'" align="center">
              <template slot="header">
                <div>实际数</div>
                <div>X+Y</div>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.amount+scope.row.specialAmount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :width="isPc?'':'60'" align="center">
              <template slot="header">
                <div>折算数</div>
                <div>X+Z</div>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.amount+(scope.row.specialAmount/4)).toFixed(1) }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="主问卷采集量" align="center" :width="isPc?'':'55'">
            <el-table-column prop="amount" :width="isPc?'':'55'" align="center">
              <template slot="header">
                <div>小计</div>
                <div>X</div>
              </template>
            </el-table-column>
            <el-table-column v-if="isPc" prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
            </el-table-column>
            <el-table-column v-if="isPc" prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
            </el-table-column>
          </el-table-column>

          <el-table-column label="专题问卷采集量" align="center" :width="isPc?'':'55'">
            <el-table-column prop="specialAmount" :width="isPc?'':'55'" align="center">
              <template slot="header">
                <div>实际数</div>
                <div>Y</div>
              </template>
            </el-table-column>
            <el-table-column :width="isPc?'':'60'" align="center">
              <template slot="header">
                <div>折算数</div>
                <div>Z</div>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.specialAmount/4).toFixed(1) }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
		<el-dialog
      :visible.sync="showIframe"
      center
			:width="isPc?'450px':'100%'"
      top="5vh"
    >
			<div v-if="showIframe && showWorldTop" class="iframe-box">
        <my-top :dataList="provincesAndCitiesTop" :time="updateTime"></my-top>
			</div>
      <div v-if="showIframe && showFirmTop" class="iframe-box">
        <firm-top :dataList="companyTop" :time="updateTime"></firm-top>
			</div>
      <div v-if="showIframe && showEducationTop" class="iframe-box">
        <education-top :dataList="educationTop" :time="updateTime"></education-top>
			</div>
		</el-dialog>
    <el-dialog
      :visible.sync="showPoster"
      title="喜报"
      center
      top="5vh"
      :width="isPc?'600px':'100%'"
      class="dialog-container"
    >
      <div style="height: 100%;">
        <el-carousel arrow="always" trigger="click" :autoplay="false" :height="isPc?'1060px':'780px'" indicator-position="none">
          <template v-if="posterData.type === 1">
            <el-carousel-item v-for="item in 3" :key="item">
              <poster :type="item" :isPc="isPc" :amount="posterData.amount" :rowData="posterData.rowData" :name="posterData.name" :time="updateTime"></poster>
            </el-carousel-item>
          </template>
          <template v-if="posterData.type === 2">
            <el-carousel-item v-for="item in 5" :key="item">
              <poster-s :type="item" :rowData="posterData.rowData" :totalAmount="posterData.totalAmount" :name="posterData.name" :time="updateTime"></poster-s>
            </el-carousel-item>
          </template>
          <template v-if="posterData.type === 3">
            <el-carousel-item v-for="item in 5" :key="item">
              <poster-s :type="item" :rowData="posterData.rowData" :totalAmount="posterData.totalAmount" :name="posterData.name" :time="posterData.rowData.time"></poster-s>
            </el-carousel-item>
          </template>
        </el-carousel>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showPlacardInfoDialog"
      title="全国喜报配置"
      center
      top="5vh"
      :width="isPc?'600px':'95%'"
      class="dialog-container"
    >
      <placard-info @submit="submitFrom"></placard-info>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import * as echarts from 'echarts'
import geojson from './geojson.json' // 无省市后缀
// import geojson from './china.json' // 有省市后缀
import MyTop from './top.vue';
import FirmTop from './firmTop.vue';
import EducationTop from './educationTop.vue';
import poster from './poster.vue';
import posterS from './posterS.vue';
import wall from './wall.vue';
import placardInfo from './placardInfo.vue';

// 创建一个axios实例
const apiInstance = axios.create({
  // baseURL: 'https://myd.iscn.org.cn',
  baseURL: 'https://myd-api.iscn.org.cn',
  // headers: {
  //   'Content-Type': 'application/json'
  // },
});
var myChart;
export default {
  name: 'Home',
  components: {
    'my-top': MyTop,
    'firm-top': FirmTop,
    'education-top': EducationTop,
    'poster': poster,
    'poster-s': posterS,
    'wall': wall,
    'placard-info': placardInfo
  },
  data() {
    return {
      urlBase: '/tduck-api', // 接口公共前缀
      showPoster: false,
      showPlacardInfoDialog: false,
      posterData: {
        type: 1,
        name: '',
        amount: 0,
        rowData: {},
        qrCode: '',
        totalAmount: 0,
        specialAmount: 0,
      },
      publicFormKey: "S8Xy1gxC", // 正式
      employmentFormKey: 'nFmRfbow', // 正式
      // publicFormKey: "By5Htiaj",
      // employmentFormKey: 'QNiBa3sN',
      geojsonData: {},
      theme: {
        isRed: true,
        bg: 'bg2024_1.jpg',
        bgColor: "#FEC27C",
        titleBg: 'title2023_1.png',
        themeColor: "#EA3E14",
        otherBgColor: "#2AA1FF",
        tabbt: 'tabbt2024_1.png',
        tabsBg: 'custom-tabs-red',
        subheadBg: 'subhead2023_special1.png',
        lableBg: 'lable2024_1.png',
        textColor: 'red'
      },
      year: 2024,
      // 菜单
      activeTab: [
        {
          active: 2,
          title: "参与答题网民", // 按ip统计
          titleS: "",
          titleF: "区域分布",
          tip: " (汇总统计)",
          show: true,
          children: [
            {
              id: 1,
              identification: 'first',
              title: "样本采集（汇总统计）",
              parentId: 2,
            },
            {
              id: 2,
              identification: 'second',
              title: "主问卷/专题采集量（数量汇总）",
              parentId: 2,
            }
          ]
        },
        {
          active: 1,
          title: "各省市实际", // 按来源统计
          titleS: "",
          titleF: "采集量",
          tip: " (汇总统计)",
          show: false,
          children: []
        },
        {
          active: 6,
          title: "各链接",
          titleS: "",
          titleF: "采集量",
          tip: " ",
          show: false,
          children: []
        },
        {
          active: 5,
          title: "发起单位",
          titleS: "",
          titleF: "采集量",
          tip: " ",
          show: false,
          children: [
            {
              id: 1,
              identification: 'first',
              title: "发起单位",
              parentId: 5,
            },
            {
              id: 3,
              identification: 'three',
              title: "联合发起单位",
              parentId: 5,
            },
            // 推荐单位链接需要放开
            // {
            //   id: 2,
            //   identification: 'second',
            //   title: "推荐单位",
            //   parentId: 5,
            // }
          ]
        },
        {
          active: 8,
          title: "志愿",
          titleS: "服务",
          titleF: "",
          tip: " ",
          show: false,
          children: [
            {
              id: 1,
              identification: 'first',
              title: "网安联·志愿服务站",
              parentId: 8,
            },
            {
              id: 2,
              identification: 'second',
              title: "网安联·志愿服务队",
              parentId: 8,
            },
            {
              id: 4,
              identification: 'four',
              title: "其他志愿团体",
              parentId: 8,
            },
            {
              id: 5,
              identification: 'five',
              title: "公益讲师",
              parentId: 8,
            },
            {
              id: 3,
              identification: 'three',
              title: "志愿者",
              parentId: 8,
            }
          ]
        },
        // {
        //   active: 10,
        //   title: "喜报墙",
        //   titleS: "",
        //   titleF: "",
        //   tip: " ",
        //   show: false,
        //   children: [
        //     {
        //       id: 1,
        //       identification: 'first',
        //       title: "发起单位",
        //       parentId: 10,
        //       topList: [
        //         {
        //           id: 1,
        //           name: '发起单位',
        //           topData: []
        //         },
        //         {
        //           id: 2,
        //           name: '联合发起单位',
        //           topData: []
        //         }
        //       ]
        //     },
        //     {
        //       id: 2,
        //       identification: 'two',
        //       title: "志愿服务团体(个人)",
        //       parentId: 10,
        //       topList: [
        //         {
        //           id: 1,
        //           name: '网安联·志愿服务站',
        //           topData: []
        //         },
        //         {
        //           id: 2,
        //           name: '网安联·志愿服务队',
        //           topData: []
        //         },
        //         {
        //           id: 3,
        //           name: '其他志愿服务团体',
        //           topData: []
        //         },
        //         {
        //           id: 4,
        //           name: '网安联公益讲师',
        //           topData: []
        //         },
        //         {
        //           id: 5,
        //           name: '志愿者',
        //           topData: []
        //         }
        //       ]
        //     },
        //     {
        //       id: 3,
        //       identification: 'three',
        //       title: "党政机关",
        //       parentId: 10,
        //       topList: [
        //         {
        //           id: 1,
        //           name: '公安',
        //           topData: []
        //         },
        //         {
        //           id: 2,
        //           name: '网信',
        //           topData: []
        //         },
        //         {
        //           id: 3,
        //           name: '密码',
        //           topData: []
        //         },
        //         {
        //           id: 4,
        //           name: '教育',
        //           topData: []
        //         },
        //         {
        //           id: 5,
        //           name: '卫健',
        //           topData: []
        //         },
        //         {
        //           id: 6,
        //           name: '街道社区/乡镇',
        //           topData: []
        //         },
        //         {
        //           id: 7,
        //           name: '其他',
        //           topData: []
        //         }
        //       ]
        //     },
        //     {
        //       id: 4,
        //       identification: 'four',
        //       title: "社会组织",
        //       parentId: 10,
        //       topList: [
        //         {
        //           id: 1,
        //           name: '商协会/学会',
        //           topData: []
        //         },
        //         {
        //           id: 2,
        //           name: '民办非企业',
        //           topData: []
        //         },
        //         {
        //           id: 3,
        //           name: '基金会',
        //           topData: []
        //         }
        //       ]
        //     },
        //     {
        //       id: 5,
        //       identification: 'five',
        //       title: "企事业单位",
        //       parentId: 10,
        //       topList: [
        //         {
        //           id: 1,
        //           name: '企业',
        //           topData: []
        //         },
        //         {
        //           id: 2,
        //           name: '科研机构',
        //           topData: []
        //         },
        //         {
        //           id: 3,
        //           name: '医卫单位',
        //           topData: []
        //         },
        //         {
        //           id: 4,
        //           name: '银行',
        //           topData: []
        //         },
        //         {
        //           id: 5,
        //           name: '事业单位',
        //           topData: []
        //         },
        //         {
        //           id: 6,
        //           name: '媒体',
        //           topData: []
        //         },
        //         {
        //           id: 7,
        //           name: '学校',
        //           topData: []
        //         },
        //         {
        //           id: 8,
        //           name: '其他',
        //           topData: []
        //         }

        //       ]
        //     },
        //     {
        //       id: 6,
        //       identification: 'other',
        //       title: "其他",
        //       parentId: 10,
        //       topList: [
        //         {
        //           id: 1,
        //           name: '其他',
        //           topData: []
        //         }
        //       ]
        //     }
        //   ]
        // },
      ],
      nowActive: {},
			tableKey: 2,
      totalAreaData: [], //参与答题网民区域分布
      provincesAndCitiesData: [], // 各省市实际采集量
      collectBaseList: [], //采集量数据公众
      recommendTableData: [], //推荐单位采集量表格数据
      initiateTableData: [], //发起单位
      jointTableData: [], //联合发起单位
      volunteerTabTableData: [], // 志愿服务数据
      volunteerTableData: [], // 志愿者
      subjectTableData: [], // 主问卷/专题采集量 （数量汇总）
      sortList: [], //分类数据
      recommendTableDataLoading: false,
      volunteerLoading: false,
      tableDataLoading: false,
      tableDataAreaLoading: false,
      thePublicLoading: false,
      subjectLoading: false,
      loading: false,
      // 服务站：volunteerOrgName
      // 服务队：volunteerUnitName
      // 志愿者：sourceName
      toolData: {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: ''
      },
      provinceList: [],
      cityList: [],
      //对话框
      dialogRecommendTable: false,
      dialogRecommendTitle: '',
      dialogRecommendData: [],
      dialogRecommendLoading: false,
      showMap: false, //地图
      dealMapData: [],
			showIframe: false,
			showWorldTop: false, // 全国前十
			showFirmTop: false, // 企业前十
			showEducationTop: false, // 教育前十
			isCity: false,
			updateTime: "",
      posterActiveName: 'first',
      volunteerActiveName: 'first',
      areaActiveName: 'first',
      unitActiveName: 'first',
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      dialogWidth: '450px',
      tableWidth: 'width:100%',
      isPc: true,
      provincesAndCitiesTop: [],
      companyTop: [],
      educationTop: [],
      firmList: [], // 企业采集量
      cityTableData: [], // 城市列表
      cityTableDataTop100: [], // 城市列表
      dialogcityTop: false,
      dialogcityTopLoading: false,
      areaCityTableData: [], // 城市列表
      areaCityTableDataTop100: [], // 城市列表
      dialogAreaCityTop: false,
      dialogAreaCityTopLoading: false,
      nowPosterData: {
        id: null,
        identification: '',
        title: "",
        parentId: null,
        topList: []
      }
    };
  },
  created() {

    this.nowActive = this.activeTab[0],
		this.geojsonData = geojson;
    this.func_get_sort(); // 获取分类
    // this.changeTab(this.nowActive.active)
  },
  mounted() {
    const that = this;
    window.onresize = ()=> {
      return (()=> {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = document.body.clientHeight;
        that.screenHeight = window.screenHeight;
      })()
    }
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        if(newVal>768) {
          this.dialogWidth = "450px";
          // this.tableWidth = `width:${newVal}`
          this.isPc = true;

        }else {
          this.dialogWidth = "90%"
          // this.tableWidth = `width:${newVal}`
          this.isPc = false;
        }
      }
    }
  },
	updated() {
    this.$nextTick(() => {
      // this.$refs['table'].doLayout();
      // this.$refs['area'].doLayout();
    })
  },
  beforeUnmount() {
  },
  filters: {
    filterId: function (value) {
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return value
      }else {
        return ' '
      }
    },
    filterIdS: function (value) {
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return value
      }else if (count===1) {
        let ary = value.split('-')
        return `(${ary[count]})`
      }else if (count===2) {
        let ary = value.split('-')
        return `[${ary[count]}]`
      }else {
        return ' '
      }
    },
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if(rowIndex === 0&&!this.isPc) {
        if (columnIndex === 1) {
          return [0, 0];
        } else if (columnIndex === 2) {
          return [1, 2];
        }
      }
    },
    filterActive: function ( tab ) {
      let obj = this.activeTab.find(item=>item.active === this.nowActive.active);
      let tabObj = obj.children.find(item=>item.identification === tab);
      return !!tabObj.title?tabObj.title: ''
    },
    getPlacardInfo() {
      this.showPlacardInfoDialog = true;
    },
    submitFrom(info) {
      this.createPlacard(info, 3)
    },
    createPlacard(row, type) {
      this.showPoster = false;
      this.loading = true;
      if(!!this.updateTime) {
        if(type === 1) { // 服务队/个人喜报
          let title = row.name;
          this.posterData = {
            type: 1,
            name: title,
            amount: row.amount+(!!row.specialAmount?row.specialAmount:0),
            rowData: row,
            qrCode: '',
            totalAmount: 0,
            specialAmount: 0,
          }
        }else if(type === 2) { // 网民喜报
          let title = row.name;
          if(row.name === '合计') {
            title = '全国';
          }
          this.posterData = {
            type: type,
            name: title,
            qrCode: '',
            rowData: row,
            totalAmount: row.totalAmount,
          }
        }else if(type === 3) { // 网民喜报
          this.posterData = {
            type: type,
            name: row.name,
            qrCode: '',
            rowData: row,
            totalAmount: row.totalAmount,
          }
        }

        this.showPoster = true;
        this.$nextTick(()=>{
          setTimeout(()=>{
            this.loading = false;
          }, 1000)
        });
      }

    },
    clickDropdownMenu(command) {
      let active = command.parentId;
      this.toolData = {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: ''
      };
      if (active == 1) {
        this.provinceCity();
      }else if (active == 2) {
        this.getSubject();
        this.areaActiveName = command.identification;
        this.changeAreaTabelTab({name: command.identification})
      }else if (active == 6) { // 各链接采集量公众网民版,来源
        this.getSource(100);
      } else if (active == 5) { // 推荐单位采集量
        // this.getUnit();
        this.unitActiveName = command.identification;
        this.changeUnitTabelTab({name: command.identification})
      } else if (active == 8) {
          this.volunteerActiveName = command.identification;
          this.getVolunteerTabData(command.identification)
      } else if (active == 10) {
          this.posterActiveName = command.identification;
          this.changePosterTabelTab({
            active: 10,
            name: command.identification
          })
      }
      this.activeTab.forEach(e => {
        e.show = false;
        if (e.active == active) {
          e.show = true;
          this.nowActive = e;
          return
        }

      });
      this.showMap = false; // 切换时隐藏地图
    },
    changeTheme() {
      this.$confirm('是否切换主题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        if(this.theme.isRed) {
          this.theme= {
            isRed: false,
            bg: 'bg2024_2.jpg',
            bgColor: "#A2E1FF",
            titleBg: 'title2023_2.png',
            themeColor: "#2AA1FF",
            otherBgColor: "#EA3E14",
            subheadBg: 'subhead2023_special2.png',
            lableBg: 'lable2024_2.png',
            tabbt: 'tabbt2024_2.png',
            tabsBg: 'custom-tabs-no-red',
            textColor: 'blue'
          };
        }else {
          this.theme= {
            isRed: true,
            bg: 'bg2024_1.jpg',
            bgColor: "#FEC27C",
            titleBg: 'title2023_1.png',
            themeColor: "#EA3E14",
            otherBgColor: "#2AA1FF",
            tabbt: 'tabbt2024_1.png',
            tabsBg: 'custom-tabs-red',
            subheadBg: 'subhead2023_special1.png',
            lableBg: 'lable2024_1.png',
            textColor: 'red'
          }
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    changeProvince(val) {
      // provinceList: [],
      // cityList: [],
      this.cityList = [];
      if(!!val) {
        let cityData = this.provinceList.filter(item => item.province === val)
        this.cityList = cityData[0].childrenList;
      }
    },
    // 查询栏目点击搜索
    searchEvent() {
      if (this.nowActive.active == 6) { // 各链接采集量公众网民版,来源
        this.getSource(0);
      } else if (this.nowActive.active == 5) { // 推荐单位采集量
        if(this.unitActiveName === 'second') {
          this.getRemarkUnit();
        }else if(this.unitActiveName === 'three'){
          this.getJointUnit();
        }else {
          this.getUnit();
        }
      } else if (this.nowActive.active == 8) {
        this.getVolunteerTabData(this.volunteerActiveName);
      }
    },
    // 全国企业采集量
    worldCollect() {
      this.dialogRecommendTable = true;
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = "全国企业采集量";

      this.dialogRecommendData = this.firmList;
      this.dialogRecommendLoading = false;
    },
    findIdByCategoryName(categories, categoryName) {
      for (let i = 0; i < categories.length; i++) {
        if (categories[i].categoryName === categoryName) {
          return categories[i].id; // 返回找到的第一个匹配项的 id
        }
        if (categories[i].children && categories[i].children.length > 0) {
          const id = this.findIdByCategoryName(categories[i].children, categoryName);
          if (id) return id; // 如果在子级中找到匹配项，返回其 id
        }
      }
      return null; // 如果没有找到匹配项，返回 null
    },
    byCategoryFindTop(type,categoryName, congratulationSize) {
      const id = this.findIdByCategoryName(this.sortList, categoryName);
      let params = {
        congratulationSize: congratulationSize,
        categoryId: id,
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/congratulation`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
          if(type === 1) {
            if(categoryName === '学校') {
              this.educationTop = data.data.childrenList;
              this.showWorldTop = false;
              this.showFirmTop = false;
              this.showEducationTop = true;
              this.showIframe = true;
            }else if(categoryName === '企业') {
              this.companyTop = data.data.childrenList;
              this.showWorldTop = false;
              this.showEducationTop = false;
              this.showFirmTop = true;
              this.showIframe = true;
            }
          }
          this.dialogRecommendLoading = false;
      }).catch( err => {
        this.loading = false;
        this.dialogRecommendLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    educationCollect(type, categoryName) {
      const id = this.findIdByCategoryName(this.sortList, categoryName);
      if(type == 1) {
        this.dialogRecommendTable = true;
        this.dialogRecommendLoading = true;
        this.dialogRecommendTitle = `全国${categoryName}采集量`;
      }else if(type == 2) {

      }
      this.loading = true;
      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey,
        sourceName: '',
        province: '',
        categoryId: id,
        city: '',
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/city/source`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList.sort(function (a, b) {
          return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
        });
        if(type == 1) {
          if(childrenList.find(item => item.category === '合计') === undefined ) {
            this.dialogRecommendData = this.addTotal(childrenList);
          }
        }else if(type == 2) {
          // 教育前十
          let dataEducation = [];
          for(let item in childrenList) {
            let name = childrenList[item].name;
            if(!!name && name!=='/' && name!=='合计') {
              dataEducation.push({
                name: name,
                amount: childrenList[item].amount+childrenList[item].specialAmount
              })
            }
            if(dataEducation.length >=10) {
              break
            }
          }
          this.educationTop = dataEducation;
          this.showWorldTop = false;
          this.showFirmTop = false;
          this.showEducationTop = true;
          this.showIframe = true;
        }
        this.loading = false;
        this.dialogRecommendLoading = false;
      }).catch( err => {
        this.loading = false;
        this.dialogRecommendLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });

    },
    cityCollect() {
      this.dialogcityTop = true;
      this.dialogcityTopLoading = true;
      this.$nextTick(function() {
        this.dialogcityTopLoading = false;
      });
    },
    areaCityCollect() {
      this.dialogAreaCityTop = true;
      this.dialogAreaCityTopLoading = true;
      this.$nextTick(function() {
        this.dialogAreaCityTopLoading = false;
      });
    },
    // 2023 省市统计
    provinceCity() {
      this.loading = true;
      this.tableDataLoading = true;
      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/city`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        this.cityTableData = [];
        this.cityTableDataTop100 = [];
        // 过滤数据，过滤掉包含“志愿服务支队”
        let filteredData = this.filterData(data.data.childrenList, '志愿服务支队');
        //排序
        let childrenList = filteredData.sort(function (a, b) {
          return (b.amount) - (a.amount);
        });
        // 加id,过滤数据获取全国
        childrenList = this.getChild(childrenList);
        setTimeout(()=> {
          this.getsumrow(childrenList)
          this.provincesAndCitiesData = childrenList; // 省市实际采集量
          this.tableDataLoading = false;
          this.loading = false;
          // 获取城市top100
          this.cityTableData.sort(function (a, b) {
            return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
          });
          this.cityTableDataTop100 = this.cityTableData.filter(item => item.city !== '总队').slice(0, 100);
        },0)
      }).catch( error => {
        this.tableDataLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    filterData(arr=[], str='' ) {
      return arr.filter(item => {
        // 如果当前项包含“志愿服务支队”，则不保留该项
        if (item.name.includes(str)) {
          return false;
        }
        // 递归过滤子级
        if(item.hasOwnProperty('childrenList')) {
          item.childrenList = this.filterData(item.childrenList, str);
        }
        return true;
      });
    },
    addTotal(arr=[]) {
      if (!!arr&&arr.length>0) {
        let total = arr.reduce((acc, cur) => {
          for (const key in cur) {
            if(typeof acc[key] === 'undefined') {
              acc[key] = 0;
            }
            if(key ==='amount'||key ==='employmentAmount'||key ==='publicAmount'||key ==='specialAmount'||key ==='percent') {
              acc[key] += cur[key];
            }else {
              acc[key] = ''
            }
          }
          return acc;
        }, {});

        total.id = '0';
        total.name = '/';
        total.category = '合计';
        total.city = '/';
        total.province = '/';
        total.sourceName = '/';
        total.startCompany = '/';
        arr.unshift(total);
      }
      return arr
    },
    //province省->city市->district区->sourceName来源
    getChild(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index + 1;
          }else {
            element.id = idx + '-' + ( index + 1 );
          }
          element.isClick = true;
          let count = this.countCharacterOccurrences(element.id, '-')
          if(count === 0 ) { // 0当前是省，1当前是市、
            if(element.province!=="组委会") {
              let arr = [];
              element.childrenList.forEach(it => {
                it.province = element.province;
                if(it.city!=="协会" && it.city!=="组委会") {
                  arr.push(it)
                }
              });
              this.cityTableData = [...this.cityTableData, ...arr]
            }
          }
          if(element.hasOwnProperty('childrenList')) {
            this.getChild(element.childrenList, element.id)
          }
        });
      }
      return data;
    },
    // 判断某个字符在字符串中出现的次数
    countCharacterOccurrences(string, character) {
      let count = 0;
      for (let i = 0; i < string.length; i++) {
        if (string.charAt(i) === character) {
          count++;
        }
      }
      return count;
    },
    // 2023 来源统计
    getSource(limit=0) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.thePublicLoading = true;
      let categoryId = null;
      if (!!this.toolData.category&&this.toolData.category.length > 0) {
        categoryId = this.toolData.category.at(-1);
      }
      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey,
        sourceName: this.toolData.sourceName,
        province: this.toolData.province,
        categoryId: categoryId,
        city: this.toolData.city,
        limit: limit,
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/city/source`, params, { timeout: 20000 }).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.summation&&Object.keys(data.data.summation).length!==0) {
          data.data.childrenList.unshift(data.data.summation);
        }
        // this.collectBaseList = data.data.childrenList.filter(item => item.sourceName !== '肇庆市信息协会');
        if( this.toolData.sourceName.includes('志愿服务支队') ) {
          this.collectBaseList = []
        }else {
          this.collectBaseList = data.data.childrenList.filter(item => {
            // 如果当前项包含“志愿服务支队”，则不保留该项
            if (item.sourceName.includes('志愿服务支队')||item.sourceName === '肇庆市信息协会') {
              return false;
            }
            return true;
          });
        }

        this.provinceList = data.data.provinceList;
        let ref = 'thePublic';
        setTimeout(()=>{
          this.$refs[ref].doLayout()
          this.thePublicLoading = false;
          loading.close();
        },0)

      }).catch( err => {
        this.thePublicLoading = false;
        loading.close();
        this.$message.error('出错了，请联系工作人员！');
      });
		},
    // areaCityTableData: [], // 城市列表
    //   areaCityTableDataTop100: [], // 城市列表
    //   dialogAreaCityTop: false,
    //   dialogAreaCityTopLoading: false,

    // 2023按单位统计
    getUnit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.recommendTableDataLoading = true;
      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey,
        startCompany: this.toolData.recommended,
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/company`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList.sort(function (a, b) {
          return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
        });
        this.getsumrow(childrenList)
        this.initiateTableData = this.addId(childrenList); // 发起单位
        this.recommendTableDataLoading = false;
        loading.close();
      }).catch( err => {
        this.recommendTableDataLoading = false;
        loading.close();
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getsumrow(data) {
      if(!!data&&data.length > 0) {
        let total = data.reduce((acc, cur) => {
          for (const key in cur) {
            if(typeof acc[key] === 'undefined') {
              acc[key] = 0;
            }
            if(key ==='amount'||key ==='employmentAmount'||key ==='publicAmount'||key ==='specialAmount'||key ==='percent') {
              acc[key] += cur[key];
            }else {
              acc[key] = ''
            }
          }
          return acc;
        }, {});
        total.id = '0';
        total.percentDesc = `${(total.percent*100).toFixed(0)}%`;
        // total.percentDesc = '100%';
        total.name = '合计';
        total.startCompany = '合计';
        data.unshift(total);
      }
    },
    // 推荐单位
    getRemarkUnit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.recommendTableDataLoading = true;
      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey,
        remarks: this.toolData.recommended,
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/remark`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList.sort(function (a, b) {
          return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
        });
        this.getsumrow(childrenList)
        this.recommendTableData = this.addId(childrenList); // 推荐单位
        this.recommendTableDataLoading = false;
        loading.close();
      }).catch( err => {
        this.recommendTableDataLoading = false;
        loading.close();
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 联合发起单位 /myd/count/2024/company/union
    getJointUnit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.recommendTableDataLoading = true;
      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey,
        unionStartCompany: this.toolData.recommended,
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/company/union`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList.sort(function (a, b) {
          return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
        });
        this.getsumrow(childrenList) // 加合计列
        this.jointTableData = this.addId(childrenList); // 推荐单位
        this.recommendTableDataLoading = false;
        loading.close();
      }).catch( err => {
        this.recommendTableDataLoading = false;
        loading.close();
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    addId(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index;
          }else {
            element.id = idx + '-' + ( index + 1 );
          }
          if(element.hasOwnProperty('childrenList')) {
            this.addId(element.childrenList, element.id)
          }
        });
      }
      return data
    },
    // 点击推荐单位
    clickRecommend(row, index) {
      this.dialogRecommendTable = true;
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = row.name;
      if(!!row.sourceList && row.sourceList.length > 0) {
        let childrenList = []
        if(row.sourceList.find(item => item.category === '合计') === undefined ) {
          if(this.nowActive.active === 1) { // 用主问卷排序
            childrenList = row.sourceList.sort(function (a, b) {
              return (b.amount) - (a.amount);
            });
            let addTotalData = this.addTotal(childrenList);
            this.dialogRecommendData = addTotalData.filter(item => {
              // 如果当前项包含“志愿服务支队”，则不保留该项
              if (item.sourceName.includes('志愿服务支队')) {
                return false;
              }
              return true;
            });
          }else {
            childrenList = row.sourceList.sort(function (a, b) {
              return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
            });
            this.dialogRecommendData = this.addTotal(childrenList);
          }
        }else {
          this.dialogRecommendData = row.sourceList.filter(item => {
            // 如果当前项包含“志愿服务支队”，则不保留该项
            if (item.sourceName.includes('志愿服务支队')) {
              return false;
            }
            return true;
          });
        }
      }else {
        this.dialogRecommendData = []
      }
      this.dialogRecommendLoading = false;
    },
    getVolunteerTabData(identification) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.showMap = false;
      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey,
        volunteerOrgName: '',
        volunteerUnitName: '',
        sourceName: '',
        otherVolunteerOrgName: '',
        publicInstructor: ''
      }
      let url = ''
      if(identification === 'first') {
          url = `/myd/count/2024/volunteer/orgName`;
          params.volunteerOrgName = this.toolData.volunteerOrgName;
      }else if(identification === 'second') {
          url = `/myd/count/2024/volunteer/unitName`;
          params.volunteerUnitName = this.toolData.volunteerOrgName;
      }else if(identification === 'three') {
          url = `/myd/count/2024/volunteer/person`;
          params.volunteer = this.toolData.volunteerOrgName;
      }else if(identification === 'four') {
          url = `/myd/count/2024/volunteer/other`;
          params.otherVolunteerOrgName = this.toolData.volunteerOrgName;
      }else if(identification === 'five') {
          url = `/myd/count/2024/volunteer/instructor`;
          params.publicInstructor = this.toolData.volunteerOrgName;
      }
      apiInstance.post(`${this.urlBase}${url}`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList.sort(function (a, b) {
          return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
        });

        let ref = `volunteer${!!identification?identification:'first'}`;
        setTimeout(()=> {
          this.$refs[ref].doLayout()
          this.getsumrow(childrenList) // 加合计列
          this.volunteerTabTableData = this.addId(childrenList);
          this.volunteerLoading = false;
          loading.close();
        },0)
      }).catch( error => {
        this.volunteerLoading = false;
        loading.close();
        this.$message.error('出错了，请联系工作人员！');
      });
    },

    // 专题统计接口：/myd/count/city/address/
    getSubject() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.subjectLoading = true;
      this.tableDataAreaLoading = true;

      let params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/city/address/special`, params).then(res => {
        let { data } = res;
        this.areaCityTableData = []; // 城市列表
        this.areaCityTableDataTop100 = []; // 城市列表
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        this.getAreaChild(data.data.childrenList)
        setTimeout(()=> {
          if(data.data.childrenList.length>0) {
            const total = data.data.childrenList.reduce((acc, cur) => {
              for (const key in cur) {
                if (typeof acc[key] === 'undefined') {
                  acc[key] = 0;
                }
                acc[key] += cur[key];
              }
              return acc;
            }, {});
            total.id = '0';
            total.name = '合计';
            total.specialPercentDesc = '100.00%';
            total.percentDesc = '100.00%';
            data.data.childrenList.unshift(total);
            this.subjectTableData = data.data.childrenList;
            this.totalAreaData = data.data.childrenList;
          }
          this.areaCityTableData.sort(function (a, b) {
            return (b.amount+b.specialAmount) - (a.amount+a.specialAmount);
          });
          this.areaCityTableDataTop100 = this.areaCityTableData.slice(0, 100);
          this.subjectLoading = false;
          this.tableDataAreaLoading = false;
          loading.close();
        },0)
      }).catch( error => {
        this.subjectLoading = false;
        this.tableDataAreaLoading = false;
        loading.close();
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getAreaChild(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index+1;
          }else {
            element.id = idx + '-' + (index+1);
          }
          element.isClick = false;
          let count = this.countCharacterOccurrences(element.id, '-')
          element.sublist = [];
          if(count === 0 ) { // 0当前是省，1当前是市
            element.sublist = element.childrenList;
            if(element.province!=="组委会") {
              let arr = [];
              element.childrenList.forEach(it => {
                it.province = element.province;
                if(it.city!=="协会" && it.city!=="组委会") {
                  arr.push(it)
                }
              });

              this.areaCityTableData = [...this.areaCityTableData, ...arr]
            }
          }
          if(element.hasOwnProperty('childrenList')) {
            this.getAreaChild(element.childrenList, element.id)
          }
        });
      }
    },

    //获取分类
    func_get_sort() {
      // /form/source/category/hierarchicalList
      apiInstance.post(`${this.urlBase}/form/source/category/hierarchicalList`, {
        year: this.year
      },{
        Accept: "application/json"
      }).then(res => {
        let { data } = res;
        this.sortList = data.data
        this.changeTab(this.nowActive.active)
      }).catch( error => {
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 各链接采集量
    getSummariesSecond(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if(this.isPc) {
          if (index === 0 ) {
            sums[index] = '0';
            return;
          }else if(index === 2 || index ===1 || index ===3|| index ===4) {
            sums[index] = '/';
            return;
          } else if (index === 5) {
            sums[index] = '合计';
            return;
          }
        }else {
          if (index === 0 ) {
            sums[index] = '0';
            return;
          }else if(index === 2 || index ===1) {
            sums[index] = '/';
            return;
          } else if (index === 3) {
            sums[index] = '合计';
            return;
          }
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 推荐单位采集量 合计列
    getSummariesZG(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => item[column.property]);
        let sum = 0;
        values.forEach(function(item,index){
          if(item==null){
            item=0
          }
          if(typeof(item) == 'string'&&item.indexOf('%')>0){
            item=Number(item.split('%')[0])
          }
          var aaa = Number(item)
          if(!isNaN(aaa)){
            sum = sum + Number(item)
          }else{
            sum = null
          }
        })
        if (index === 0) {
          sums[index] = '0';
          return;
        }
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        if (index === 2||index === 4||index === 5) {
          sums[index] = sum;
          return;
        }
        if (index === 3) {
          sums[index] = Math.round(sum).toFixed(2) + "%";
          return;
        }
      });
      return sums;
    },
    // 发起推荐单位采集量 合计列
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => item[column.property]);
        let sum = 0;
        values.forEach(function(item,index){
          if(item==null){
            item=0
          }
          if(typeof(item) == 'string'&&item.indexOf('%')>0){
            item=Number(item.split('%')[0])
          }
          var aaa = Number(item)
          if(!isNaN(aaa)){
            sum = sum + Number(item)
          }else{
            sum = null
          }
        })
        if (index === 0) {
          sums[index] = '0';
          return;
        }
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        if (index === 2 || index === 4 || index === 5) {
          sums[index] = sum;
          return;
        }
        if (index === 3) {
          sums[index] = Math.round(sum).toFixed(2) + "%";
          return;
        }
      });
      return sums;
    },
    getSummariesVolunteer(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => item[column.property]);
        let sum = 0;
        values.forEach(function(item,index){
          if(item==null){
            item=0
          }
          if(typeof(item) == 'string'&&item.indexOf('%')>0){
            item=Number(item.split('%')[0])
          }
          var aaa = Number(item)
          if(!isNaN(aaa)){
            sum = sum + Number(item)
          }else{
            sum = null
          }
        })
        if (index === 0) {
          sums[index] = '0';
          return;
        }
        if (index === 1 || index === 2) {
          sums[index] = '/';
          return;
        }
        if (index === 3) {
          sums[index] = '合计';
          return;
        }
        if (index === 4 || index === 6 || index === 7) {
          sums[index] = sum;
          return;
        }
        if (index === 5) {
          sums[index] = Math.round(sum).toFixed(2) + "%";
          return;
        }
      });
      return sums;
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 0) {
        return 'success-row';
      }
      return '';
    },
    // 专题合计
    getSubjectSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 ) {
          sums[index] = '0';
          return;
        }else if(index ===1) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '/';
        }
      });
      return sums;
    },
    changeUnitTabelTab({name}) {
      this.loading = true;
      this.recommendTableDataLoading = true;
      this.toolData.recommended = '';
      let ref= '';
      if(name=='second') {
        this.getRemarkUnit();
        ref = 'recommended'
      }else if(name=='three') {
        this.getJointUnit();
        ref = 'joint'
      }else {
        this.getUnit();
        ref = 'initiate'
      }
      setTimeout(()=>{
        this.$refs[ref].doLayout()
        this.recommendTableDataLoading = false;
        this.loading = false;
      },100)
    },
    changeAreaTabelTab({name}) {
      this.loading = true;
      this.tableDataAreaLoading = true;
      this.subjectLoading = true;
      let ref=(name=='second'?'subject':'area')
      setTimeout(()=>{
        this.$refs[ref].doLayout()
        this.tableDataAreaLoading = false;
        this.subjectLoading = false;
        this.loading = false;
      },100)
    },
    changeVolunteerTabelTab({name}) {
      this.getVolunteerTabData(name)
    },
    changePosterTabelTab({active,name}) {
      this.showMap = false;
      let nowObj = this.activeTab.find(item => item.active === active);
      let children = nowObj.children.find(item => item.identification === name);
      this.nowPosterData = children;
      let categoryId = null;
      if(this.nowPosterData.title === '发起单位') {
        this.loading = true;
        Promise.all([
          apiInstance.post(`${this.urlBase}/myd/count/2024/company`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/2024/company/union`, {})
        ]).then(([units, jointUnits]) => {
          // 将获取到的数据保存到 data 对象中
          let unitsData = units.data.data.childrenList;
          let jointUnitsData = jointUnits.data.data.childrenList;
          this.nowPosterData.topList.forEach(it => {
            it.topData = []
            if(it.name=== '发起单位' && unitsData.length > 0) {
              // 排序：降序
              unitsData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = unitsData.slice(0, 10);
            }else if(it.name=== '联合发起单位' && jointUnitsData.length > 0) {
              // 排序：降序
              jointUnitsData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = jointUnitsData.slice(0, 10);
            }
          });
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          console.error('请求数据失败:', error);
        });
      }else if(this.nowPosterData.title === '志愿服务团体(个人)') {
        this.loading = true;
        Promise.all([
          apiInstance.post(`${this.urlBase}/myd/count/2024/volunteer/orgName`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/2024/volunteer/unitName`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/2024/volunteer/person`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/2024/volunteer/other`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/2024/volunteer/instructor`, {}),
        ]).then(([orgName, unitName, person, other, instructor]) => {
          // 将获取到的数据保存到 data 对象中
          let orgNameData = orgName.data.data.childrenList;
          let unitNameData = unitName.data.data.childrenList;
          let personData = person.data.data.childrenList;
          let otherData = other.data.data.childrenList;
          let instructorData = instructor.data.data.childrenList;
          this.nowPosterData.topList.forEach(it => {
            it.topData = []
            if(it.name=== '网安联·志愿服务站' && orgNameData.length > 0) {
              // 排序：降序
              orgNameData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = orgNameData.slice(0, 10);
            }else if(it.name=== '网安联·志愿服务队' && unitNameData.length > 0) {
              // 排序：降序
              unitNameData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = unitNameData.slice(0, 10);
            }else if(it.name=== '志愿者' && personData.length > 0) {
              // 排序：降序
              personData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = personData.slice(0, 10);
            }else if(it.name=== '其他志愿服务团体' && otherData.length > 0) {
              // 排序：降序
              otherData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = otherData.slice(0, 10);
            }else if(it.name=== '网安联公益讲师' && instructorData.length > 0) {
              // 排序：降序
              instructorData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = instructorData.slice(0, 10);
            }
          });
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          console.error('请求数据失败:', error);
        });
      }else {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.sortList.forEach(element => {
          if(element.categoryName === this.nowPosterData.title&&!!element.id) {
            categoryId = element.id;
            // this.setTopData(categoryId)
            this.nowPosterData.topList.forEach(element => {
              element.topData = []
              if(!!element.name) {
                const id = this.findIdByCategoryName(this.sortList, element.name);
                this.setTopData(id, (list) => {
                  // 使用list
                  element.topData = list;
                })
              }
            });
          }
        });
        setTimeout(() => {
          loading.close();
        }, 0);
      }
    },
    setTopData(categoryId, callback) {
      let params = {
        categoryId: categoryId,
        congratulationSize: 10,
      }
      apiInstance.post(`${this.urlBase}/myd/count/2024/congratulation`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let list = data.data.childrenList; // data.data.childrenList; 获得的数据
        if(callback) callback(list);
      }).catch( err => {
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 选择tab,改变表格数据
    changeTab(active) {
      // this.loading = true;
      this.toolData = {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: ''
      };
      if (active == 1) {
        this.provinceCity();
      }else if (active == 2) {
        this.getSubject();
      }else if (active == 6) { // 各链接采集量公众网民版,来源
        this.getSource(100);
      } else if (active == 5) { // 推荐单位采集量
        // this.getRemarkUnit();
        this.getUnit();
      } else if (active == 8) {
        this.volunteerActiveName = 'first'
        this.getVolunteerTabData('first')
      } else if (active == 10) {
          // 喜报墙
          let nowObj = this.activeTab.find(item => item.active === 10);
          this.nowPosterData = nowObj.children[0]
          this.posterActiveName = 'first';
          this.changePosterTabelTab({
            active: 10,
            name: this.nowPosterData.identification
          })

      }
      this.activeTab.forEach(e => {
        e.show = false;
        if (e.active == active) {
          e.show = true;
          this.nowActive = e;
          return
        }

      });
      this.showMap = false; // 切换时隐藏地图
      // setTimeout(() => {
      //   this.loading = false;
      // }, 1000)
    },
		// 导出数据功能
		exportData() {
      this.loading = true;
			let params = {};
			let url = '';
      params = {
        publicFormKey: this.publicFormKey,
        employmentFormKey: this.employmentFormKey
      }
			if(this.nowActive.active == 1) { // 各省市实际采集量
				url = `${this.urlBase}/myd/export/2024/city`;
			}else if(this.nowActive.active == 2) { // 参与答题网民区域分布
        if(this.areaActiveName==='first') { // 发起
          params = {
            publicFormKey: this.publicFormKey,
            employmentFormKey: this.employmentFormKey,
            activeSheetIndex: 0,
          }
        }else if(this.areaActiveName==='second') { // 发起
          params = {
            publicFormKey: this.publicFormKey,
            employmentFormKey: this.employmentFormKey,
            activeSheetIndex: 1,
          }
        }
        url = `${this.urlBase}/myd/export/2024/special`
			}else if(this.nowActive.active == 5) { // 单位
        if(this.unitActiveName==='first') { // 发起
          params = {
            publicFormKey: this.publicFormKey,
            employmentFormKey: this.employmentFormKey,
            startCompany: this.toolData.recommended,
            unionStartCompany: '',
            activeSheetIndex: 0,
          }
          url = `${this.urlBase}/myd/export/2024/company`;
        }else if(this.unitActiveName==='three') { // 联合发起
          params = {
            publicFormKey: this.publicFormKey,
            employmentFormKey: this.employmentFormKey,
            startCompany: '',
            unionStartCompany: this.toolData.recommended,
            activeSheetIndex: 1,
          }
          url = `${this.urlBase}/myd/export/2024/company`;
        }
			}else if(this.nowActive.active == 6) { // 各链接
				url = `${this.urlBase}/myd/export/2024/source`;
        let categoryId = null;
        if (!!this.toolData.category&&this.toolData.category.length > 0) {
          categoryId = this.toolData.category.at(-1);
        }
        params = {
          publicFormKey: this.publicFormKey,
          employmentFormKey: this.employmentFormKey,
          sourceName: this.toolData.sourceName,
          province: this.toolData.province,
          categoryId: categoryId,
          city: this.toolData.city,
        }
			}else if(this.nowActive.active == 8) { // 志愿服务机构
        let activeSheetIndex = 0;
        if(this.volunteerActiveName==='first') { // 志愿服务站 0
          activeSheetIndex = 0;
        }else if(this.volunteerActiveName==='second') { // 志愿服务队 1
          activeSheetIndex = 1;
        }else if(this.volunteerActiveName==='three') { // 志愿者 4
          activeSheetIndex = 4;
        }else if(this.volunteerActiveName==='four') { // 其他志愿团体 2
          activeSheetIndex = 2;
        }else if(this.volunteerActiveName==='five') { // 公益讲师 3
          activeSheetIndex = 3;
        }
				url = `${this.urlBase}/myd/export/2024/volunteer`;
        params = {
          publicFormKey: this.publicFormKey,
          employmentFormKey: this.employmentFormKey,
          activeSheetIndex: activeSheetIndex,
        }
			}
			apiInstance({
				method: 'post',
				url: url,
				data: params,
				responseType: 'arraybuffer'
			}).then(res => {
        this.loading  = false;
				let blob = new Blob([res.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
				})
				let a = document.createElement("a"); // 创建a标签
				a.style.display = "none";
				let objectUrl = URL.createObjectURL(blob);
        if(this.nowActive.active == 5) {
          a.download = `${this.year}发起单位(联合发起单位).xlsx`;
        }else {
				  a.download = `${this.year}${this.nowActive.title}${this.nowActive.titleS}${this.nowActive.titleF}.xlsx`;
        }
				a.href = objectUrl;
				a.click();
				URL.revokeObjectURL(objectUrl);
			}).catch( error => {
        this.loading  = false;
        this.$message.error('导出出错了，请联系工作人员！');
      });;
		},
    // 地图
    mapEvent() {
      this.showMap = true;
      // 开始画地图
      // <div id="mapContainer" class="calDataShow mapDivisionData"></div>
      let data = [];
      if (this.nowActive.active == 2) { //参与答题网民区域分布
        data = this.subjectTableData;
      } else if (this.nowActive.active == 1) {
        data = this.provincesAndCitiesData;
      }
      this.dealMapData = this.func_deal_map(data); // 处理地图数据

      setTimeout(() => {
        this.func_init_map(); // 初始化地图
      })
    },
		tableEvent() {
			this.showMap = false;
		},
    func_init_map() {
      let geoJson = this.geojsonData;
      var chartDom = document.getElementById('mapContainer');
      myChart = echarts.init(chartDom);
      var option;
      echarts.registerMap('china', geoJson);
      myChart.setOption(
        (option = {
          title: {
            text: '',
            left: 'center',
            subtext: '',
            sublink:
              'http://zh.wikipedia.org/wiki/%E9%A6%99%E6%B8%AF%E8%A1%8C%E6%94%BF%E5%8D%80%E5%8A%83#cite_note-12'
          },
          toolbox: {
            feature: {
              myTool1: {
                show: true,
                title: '放大',
                icon: 'image://https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/amplification.png',
                onclick: function (res) {
                  myChart.setOption({
                    series: [{
                      zoom: res.option.series[0].zoom + 0.5,
                      roam: 'move'
                    }]
                  });
                }
              },
              myTool2: {
                show: true,
                title: '还原',
                icon: 'image://https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/restore.png',
                onclick: function (res) {
                  myChart.setOption({
                    series: [{
                      zoom: 1.1,
                      roam: 'move'
                    }]
                  });
                }
              }
            }

          },
          tooltip: {
            trigger: 'item',
            // triggerOn: 'item', //点击才显示tooltip，item 图形触发，axis 坐标轴触发， none 不触发
            borderWidth: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            // formatter: '答卷数<br/>{b}:{c}'
            formatter: function (param) {
              return param.marker + " " + param.seriesName + "<br>"
                + "&nbsp;&nbsp;&nbsp;&nbsp;" + param.name + "：" + param.value + "<br>";
            }
          },
          visualMap: {
            top: 'top',
            type: "continuous",
            min: 0,
            max: 300000,
            realtime: false,
            calculable: true,
            inRange: {
              color: ['#25B0F3', '#0000CD']
            }
          },
          series: [
            {
              name: '答卷次数',
              type: 'map',
              roam: 'move',//true即为缩放+拖动
              left: "10%",                                 //组件离容器左侧的距离,百分比字符串或整型数字
              top: "10%",                                      //组件离容器上侧的距离，百分比字符串或整型数字
              right: "10%",                               //组件离容器右侧的距离,百分比字符串或整型数字
              bottom: "10%",                              //组件离容器下侧的距离,百分比字符串或整型数字
              map: 'china',
              zoom: 1.1,
              itemStyle: {
                emphasis: {
                  // 鼠标悬浮地图区域的高亮颜色
                  areaColor: '#90ED87'
                }
              },
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    fontSize: 10,
                    fontWeight: '',
                    color: '#fff' //修改地图上文字的颜色
                  }
                },
                emphasis: {
                  textStyle: {
                    color: '#000'
                  }
                }
              },
              select: {
                lable: {
                  color: '#fff'
                },
                itemStyle: {
                  areaColor: '#90ED87'
                }
              },
              data: this.dealMapData
            }
          ]
        })
      );
      option && myChart.setOption(option);
    },
    // 处理地图数据
    func_deal_map(mapObj) {
      let dealData = []
      let features = [];
      features = this.geojsonData.features;
      const sum = Object.values(mapObj.reduce((accumulator, current) => {
        const { province, amount, specialAmount } = current;

        if (!accumulator[province]) {
          accumulator[province] = { province, amount: 0, specialAmount: 0 };
        }

        accumulator[province].amount += (amount + specialAmount);

        return accumulator;
      }, {}));
      sum.forEach(item => {
        if(!!item.province) {
          dealData.push({
            name: `${item.province}`,
            value: item.amount,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return item.amount;
                },
              }
            },
          })
        }

      });
      // 防止有遗漏的省市，影响地图初始化
      features.forEach(i => {
        let result = dealData.some(item => {
          return item.name === i.properties.name
        })
        if (!result) {
          dealData.push({
            name: i.properties.name,
            value: 0,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return 0;
                },
              }
            },
          })
        }
      });
      return dealData || [];
    },
    // 两个top10
		openIframe(type) {
			// let url = ''
      let data = []
			if(type == 1) {
        // this.provincesAndCitiesData
        for(let item in this.provincesAndCitiesData) {
          let name = this.provincesAndCitiesData[item].name;
          if(!!name && name!=='/' && name!=='合计') {
            data.push({
              name: name
            })
          }
          if(data.length >=10) {
            break
          }
        }
        this.provincesAndCitiesTop = data;
        this.showWorldTop = true;
        this.showFirmTop = false;
        this.showEducationTop = false;
			}else if(type == 2) {
        // 企业前十
        for(let item in this.firmList) {
          let name = this.firmList[item].name;
          if(!!name && name!=='/' && name!=='合计') {
            data.push({
              name: this.firmList[item].associatedName,
              amount: this.firmList[item].amount+this.firmList[item].specialAmount
            })
          }
          if(data.length >=10) {
            break
          }
        }
        this.companyTop = data;
        this.showWorldTop = false;
        this.showFirmTop = true;
        this.showEducationTop = false;
      }
			this.showIframe = true;
		},
		closeIframe() {
			this.showIframe = false;
		}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-box {
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  /* background-size: contain !important; */
  background-size: 100% auto !important;
}
.calcu-content {
  min-height: 450px;
  margin: 0 auto;
  padding-bottom: 50px;
  border-radius: 0 0 10px 10px;
  padding-top: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tidings-wall-box {
  position: fixed;
  top: 15%;
  right: 0.5%;
  text-align: right;
  z-index: 99;
}
.content-start {
  position: fixed;
  top: 25%;
  right: 0.5%;
  text-align: right;
  z-index: 99;
}
.content-title {
  width: 80%;
  text-align: center;
}
.content-subhead {
  width: 32%;
  text-align: center;
}
.content-btn {
  width: 60%;
  line-height: 35px;
  font-size: 18px;
  text-align: center;
  color: #fff5bf;
	margin-bottom: 10px;
}
.content-btn .btn-box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.content-btn .btn-box .btn-box-bg {
	cursor: pointer;
  width: 15%;
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center center;
}
.content-table {
  width: 90%;
  position: relative;
  overflow: hidden;
}
.innerBg {
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
  position: relative;
}
.innerBg img {
  width: 100%;
  height: auto;
  border: 0;
  max-width: 100%;
  display: block;
}
.innerBg-box {
  /* border-top-left-radius: 15px;
  border-top-right-radius: 15px; */
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 1)
  );
  overflow: hidden;
  margin-top: -6.5%;
  padding-top: 7%;
}
.tab-box {
  background: #fff;
  margin-top: -2px;
}
.tab-title {
  text-align: center;
  font-weight: bold;
  font-size: 32px;
  padding-bottom: 25px;
}
.selection-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto 6%;
}
.selection-area .sel-tab {
  flex: 1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin: 0 10px;
	padding: 0 10px;
  height: 50px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  display: flex;
	flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  min-width: 45px;
}
.selection-area .sel-tab div {
	flex: 1;
}
.selection-area .add-tips {
  font-size: 12px;
}
.table-box {
  margin: auto;
  background: #fff;
  padding-bottom: 40px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  margin-top: -2px;
  /* max-height: 1500px; */
  min-height: 540px;
}
.table-box .table {
  margin: auto 6%;
}
.table-box .table .sel-header {
  margin: 0;
  color: #fff;
  font-size: 20px;
  text-align: center;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  position: relative;
}
.table .sel-tips {
  width: 100%;
  margin: 10px auto;
}
.table .update-time {
  /* position: absolute;
  top: 36px;
  right: 10px; */
  text-align: right;
  padding-right: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
}
.table .update-time span {
	margin-left: 2px;
}
.table .tips-top {
  /* position: absolute;
  top: 36px;
  left: 10px; */
  text-align: left;
  padding-top: 10px;
  padding-left: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  margin-bottom: -12px;
}
.table .tips-top span {
  display: inline-block;
  margin-right: 5px;
  line-height: 20px;
  text-decoration: underline;
  cursor:pointer;
}
.top-link:hover {
  color: #0a0a0a;
}
.table .tool-bar {
  margin: 10px auto;
  display: flex;
  justify-content: center;
}
.end-tool-bar {
  display: flex;
  justify-content: flex-end!important;
}
.tool-bar .tool-input {
  margin-bottom: 10px;
}
.tool-input .el-select {
  width: 100%;
}
.table .caculate-area {
  width: 100%;
  margin: 0 auto 0;
  min-height: 50px;
  /* height: 750px; */
  position: relative;
  background: #fff;
}
.caculate-area .data-scroll-area {
  /* border: 1px solid #ddd; */
  overflow: auto;
}
.dialog-box {
  /* height: 90%;
  max-height: 670px; */
  overflow: auto;
}
.mapDivisionData {
  /* width: 100%; */
  /* height: 1100px; */
}
.iframe-box {
  width: 100%;
  min-height: 640px;
  height: calc(90vw*1080/2196);
}
.iframe-box iframe {
	width: 100%;
	height: 100%;
}
/* tab样式 */
.tabs-box {
  margin: 20px auto;
}
.tabs-box /deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header {
  /* border: none; */
}
.tabs-box /deep/ .el-table {
  border: 1px solid #ddd;
}
.tabs-box /deep/ .el-tabs__header {
  margin: 0;
}
.tabs-box /deep/ .el-tabs__nav {
  border: none;
  width: 100%;
  display: flex;
  justify-content: center;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item:first-child {
  border: 1px solid #ddd;
}
.tabs-box /deep/ .el-tabs__item {
  border-radius: 5px 5px 0 0;
  border: 1px solid #ddd;
  width: 20%;
  text-align: center;
  padding: 0!important;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}
.tabs-box /deep/ .el-tabs__item:hover {
  color: #ddd;
  /* color: #303133; */
}
.tabs-box /deep/ .el-tabs__item.is-active {
  color: #fff;
  /* background-color: #F89A67; */
}
.tabs-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.custom-tabs-red /deep/ .el-tabs__item.is-active {
  background-color: #F79A67;
}
.custom-tabs-no-red /deep/ .el-tabs__item.is-active {
  background-color: #5BABE8;
}
.caculate-area /deep/ .el-table .cell {
  padding-left: 5px;
  padding-right: 5px;
  /* transform: scale(0.8); */
  line-height: 20px;
}
.total-table /deep/ .el-table__footer-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
}
.total-table /deep/ .el-table__body-wrapper {
    margin-top: 46px;
}
.total-table-2 /deep/ .el-table .success-row {
  background: #F5F7FA;
  position: sticky;
  top: 0px;
  background-color: #f5f7fa;
  z-index: 1;
}
.total-table-3 /deep/ th {
  border: 2px solid #ebeef5;
}
.total-table-3 /deep/ td {
  border: 2px solid #ebeef5;
}
.total-table-3 /deep/ .el-table th.el-table__cell>.cell {
  white-space: pre-line;
}
.content-box-title {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
}
@media screen and (max-width: 1950px) {
}
@media screen and (max-width: 1500px) {
  .content-btn {
    line-height: 28px;
    font-size: 16px;
  }
  .selection-area .sel-tab {
    font-size: 15px;
  }
}
@media screen and (max-width: 1200px) {
  .content-btn {
    line-height: 24px;
    font-size: 14px;
  }
  .selection-area .sel-tab {
    font-size: 12px;
		height: 45px;
  }
  .tab-title {
    font-size: 28px;
  }
}
@media screen and (max-width: 1024px) {
  .content-btn {
    line-height: 20px;
    font-size: 12px; /*最小了 ，后面可用缩放*/
  }
  .table-box .table .sel-header {
    font-size: 18px;
  }
  .tab-title {
    font-size: 26px;
  }
}
@media screen and (max-width: 768px) {
  .table .tool-bar {
    margin: 10px auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .tool-bar .tool-input {
    padding-bottom: 10rpx;
  }
  .tool-bar /deep/ .el-input__inner {
    padding: 0 10px;
  }
  .content-table {
    width: 95%;
  }
  .selection-area, .table-box .table {
    margin: auto 1%;
  }
  .selection-area .sel-tab {
    margin: auto 2px;
    padding: 0 5px;
    justify-content: center;
  }
  .content-btn {
    line-height: 14px;
  }
  .table-box .table .sel-header {
    font-size: 14px;
  }
  .tab-title {
    font-size: 16px;
    padding-bottom: 5px
  }
  .table .tips-top {
    margin-bottom: 0;
    font-size: 10px;
  }
  .tabs-box /deep/ .el-tabs__item {
    height: 38px;
    line-height: 38px;
    font-size: 12px;
  }
  .caculate-area /deep/ .el-button {
    padding: 2px 2px;
  }
  .caculate-area /deep/ .el-table {
    font-size: 12px;
    overflow: overlay;
  }
  .caculate-area /deep/ .el-table .cell {
    padding-left: 0px!important;
    padding-right: 0px!important;
    /* transform: scale(0.8); */
  }
  .caculate-area /deep/ .el-table .el-table__placeholder {
    width: 0px!important;
  }
  .caculate-area /deep/ .el-table .el-table__cell {
    text-align: center!important;
    padding: 5px 0;
    /* line-height: 20px; */
  }
  .total-table /deep/ .el-table__footer-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
    height: 30px;
  }
  .total-table /deep/ .el-table__body-wrapper {
    margin-top: 28px;
  }
  .dialog-container /deep/ .el-table {
    font-size: 12px!important;
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .dialog-container /deep/ .el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
    font-size: 12px!important;
    /* transform: scale(0.8); */
    line-height: 20px;
  }
  .dialog-container /deep/ .el-table .el-table__placeholder {
    width: 0px;
  }
  .dialog-container /deep/ .el-table .el-table__cell {
    text-align: center;
    padding: 2px 0;
  }
  .dialog-container /deep/ .el-dialog--center .el-dialog__body {
    padding: 5px 5px 30px;
  }
  .caculate-area /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
    width: 10px;
    margin-left: -10px;
  }
  .caculate-area /deep/ .el-table .el-table__indent {
    padding: 0!important;
  }
  .dialog-container /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
    width: 10px;
    margin-left: -10px;
  }
  .dialog-container /deep/ .el-table .el-table__indent {
    padding: 0!important;
  }
  .tabs-box /deep/ .el-tabs__nav {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .tabs-box-3 /deep/ .el-tabs__item {
    width: 32%;
    text-align: center;
  }
  .tabs-box-2 /deep/ .el-tabs__item {
    width: 48%;
    text-align: center;
  }
  .caculate-area /deep/ .el-table {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .caculate-area /deep/ .el-table th {
    /* 恢复正常字体大小 */
    font-size: 12px !important;
  }
  .caculate-area /deep/ .el-table th.is-center {
    padding: 2px 0;
    margin: 0;
    float: none;
    line-height: 20px;
  }
  .content-box-title {
    font-size: 22px;
  }
}
@media screen and (max-width: 550px) {

  .content-btn {
    line-height: 12px;
  }
}
@media screen and (max-width: 350px) {
  .table .tool-bar {
    margin: 0px;
  }
  .selection-area .sel-tab {
    margin: 0px;
    padding: 0px;
  }
  .content-btn {
    line-height: 10px;
  }
}
</style>
<style>
.custom-tabs-no-red li {
  background-color: #1A74EA;
  border: 1px solid #1A74EA;
  color: #fff !important;
  font-size: 20px !important;
}
.custom-tabs-no-red li:hover {
  border-radius: 5px;
  color: #1A74EA !important;
}
.custom-tabs-red li {
  background-color: #F79A67;
  border: 1px solid #F79A67;
  color: #fff !important;
  font-size: 20px !important;
}
.custom-tabs-red li:hover {
  border-radius: 5px;
  color: #F79A67 !important;
}
.el-dropdown-menu {
  /* background-color: #1A74EA !important ;
  border: 1px solid #1A74EA !important ; */
  border-radius: 0px;
  min-width: 180px!important;
  margin-top: 0px;
  margin: 0px 0px 0px 10px!important;
  padding: 0px!important;
  font-size: 24px!important;
  z-index: 99!important;
}
.el-popper[x-placement^=bottom]{
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 0px;
}
.el-dropdown-menu__item:not(:last-of-type){
  border-bottom:1px solid #fff;
}
/* 消除小三角 */
.el-popper[x-placement^=bottom] .popper__arrow{
  border: none;
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
  border: none;
}
@media screen and (max-width: 768px) {
  .custom-tabs-no-red li {
    font-size: 12px !important;
    line-height: 24px!important;
  }
  .custom-tabs-red li {
    font-size: 12px !important;
    line-height: 24px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue